import {api} from '../api';
import http from '../http';
import {
  ChangePasswordBody,
  ChangePasswordResponse,
} from '../../interfaces/api/tabs';
import {GetHomeTabsResponse} from '../../interfaces/api/content/home';
import {store} from '../../redux/store';
import Config from 'react-native-config';
import {HttpResponse} from '../../interfaces/api/http';
import {GetNewsResponse, NewsForm} from '../../interfaces/api/content/news';
import {GetSpecialitiesData} from '../../interfaces/api/content/speciality';

export const home = {
  getHomeTabsFilters: (): Promise<HttpResponse<GetHomeTabsResponse>> =>
    new Promise((resolve, reject) => {
      const {email, specialty_id} = store.getState().auth?.currentUser || {};
      const params = new URLSearchParams();
      if (specialty_id) {
        params.append('specialty_id', specialty_id + '');
      }
      if (email === Config.APPLE_EMAIL) {
        params.append('show', '1');
      }
      const url = `${api.content.tabFilters}?${params.toString()}`;
      http
        .get<GetHomeTabsResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  getSpecialities: (
    professionId: number,
  ): Promise<HttpResponse<GetSpecialitiesData>> =>
    new Promise((resolve, reject) => {
      const url = `${api.content.specialities}?profession_id=${professionId}`;
      http
        .get<GetSpecialitiesData>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  getNews: ({
    isRecommendations = false,
    ...newsForm
  }: NewsForm): Promise<HttpResponse<GetNewsResponse>> =>
    new Promise((resolve, reject) => {
      const {specialty_id, email} = store.getState().auth?.currentUser || {};
      const params = new URLSearchParams();
      if (email?.trim().toLowerCase() === Config.APPLE_EMAIL) {
        params.append('show', '1');
      }
      if (specialty_id) {
        params.append('specialty_id', specialty_id + '');
      }
      Object.keys(newsForm).forEach(key => {
        if (newsForm[key]) {
          params.append(key, String(newsForm[key]));
        }
      });
      const url = `${
        isRecommendations ? api.content.recommendations : api.content.news
      }?${params.toString()}`;
      http
        .get<GetNewsResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  changePassword: (
    body: ChangePasswordBody,
  ): Promise<HttpResponse<ChangePasswordResponse>> =>
    new Promise((resolve, reject) => {
      http
        .put<ChangePasswordResponse>(api.content.changePassword, body)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
};
